// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-subscribe-card--wrapper","large":"app-components-subscribe-card--large","divider":"app-components-subscribe-card--divider"};